import { connect } from 'react-redux';
import { CMAAlertCard as View } from './CMAAlertCard';

import { getBrandId } from '../../infrastructure/config/selectors';

const mapStateToProps = ({ config }) => ({ brandID: getBrandId(config) });

export const CMAAlertCard = connect(mapStateToProps)(View);
